import { extend } from './extend';
export var WorkspaceObjectType;
(function (WorkspaceObjectType) {
    WorkspaceObjectType[WorkspaceObjectType["Folder"] = 1] = "Folder";
    WorkspaceObjectType[WorkspaceObjectType["ProjectParent"] = 2] = "ProjectParent";
    WorkspaceObjectType[WorkspaceObjectType["File"] = 3] = "File";
    WorkspaceObjectType[WorkspaceObjectType["Workspace"] = 4] = "Workspace";
    WorkspaceObjectType[WorkspaceObjectType["CallTranscript"] = 5] = "CallTranscript";
    WorkspaceObjectType[WorkspaceObjectType["Brand"] = 6] = "Brand";
})(WorkspaceObjectType || (WorkspaceObjectType = {}));
export var WorkspaceObjectRole;
(function (WorkspaceObjectRole) {
    WorkspaceObjectRole[WorkspaceObjectRole["Collaborator"] = 1] = "Collaborator";
    WorkspaceObjectRole[WorkspaceObjectRole["Viewer"] = 2] = "Viewer";
    WorkspaceObjectRole[WorkspaceObjectRole["Owner"] = 3] = "Owner";
    WorkspaceObjectRole[WorkspaceObjectRole["Attendee"] = 4] = "Attendee";
})(WorkspaceObjectRole || (WorkspaceObjectRole = {}));
export var WorkspaceType;
(function (WorkspaceType) {
    WorkspaceType[WorkspaceType["Personal"] = 1] = "Personal";
    WorkspaceType[WorkspaceType["Group"] = 2] = "Group";
})(WorkspaceType || (WorkspaceType = {}));
export const WorkspaceTypeMap = new Map([
    [WorkspaceObjectType.Folder, { name: 'Folder' }],
    [WorkspaceObjectType.ProjectParent, { name: 'Project' }],
    [WorkspaceObjectType.Workspace, { name: 'Workspace' }],
    [WorkspaceObjectType.File, { name: 'File' }],
    [WorkspaceObjectType.CallTranscript, { name: 'Transcript' }],
    [WorkspaceObjectType.Brand, { name: 'Brand' }],
]);
export const WorkspaceRoleMap = {
    [WorkspaceObjectRole.Collaborator]: 'Collaborator',
    [WorkspaceObjectRole.Viewer]: 'Viewer',
    [WorkspaceObjectRole.Owner]: 'Owner',
    [WorkspaceObjectRole.Attendee]: 'Attendee',
};
const roleMap = new Map([
    [WorkspaceObjectRole.Collaborator, { name: 'Collaborator' }],
    [WorkspaceObjectRole.Viewer, { name: 'Viewer' }],
    [WorkspaceObjectRole.Owner, { name: 'Owner' }],
    [WorkspaceObjectRole.Attendee, { name: 'Attendee' }],
]);
export default {
    WorkspaceObjectRole: extend(roleMap),
    WorkspaceObjectType: extend(WorkspaceTypeMap),
};
